import { Box, Button, Typography } from "@mui/material";
import { logout } from "../../authorization/AuthorizationProvider";

const contactEmail = "team@intellident.be";

const BlockedPage = () => {
  return (
    <Box
      sx={{
        maxWidth: 520,
        mx: "auto",
        py: 6,
        textAlign: "center",
      }}
    >
      <Typography variant="h5" component="h1" gutterBottom>
        Access blocked
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        You have been blocked by an administrator. Please contact{" "}
        <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.
      </Typography>
      <Button variant="outlined" color="primary" onClick={() => logout()}>
        Sign out
      </Button>
    </Box>
  );
};

export default BlockedPage;
